import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const VolumeControl = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='VolumeControl' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,18 C15.3137085,18 18,15.3137085 18,12 C18,8.6862915 15.3137085,6 12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 Z M8,8 L11,11 M12,22 C15.4612937,22 18.5118579,20.2414583 20.3069882,17.5690793 C21.3761716,15.9774047 22,14.0615538 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12' />
  </StyledIcon>
);
